import { ReactNode, useEffect, useState } from 'react'
import { initI18next } from '@config/i18next'
import i18next from 'i18next'
import { I18nextProvider } from 'react-i18next'
import { useUserInfo } from '@shared/data/UserInfo'
import { useUserInfo as usePreferenceInfo } from '@preferences/user/data/UserInfo'

export interface MercatusI18nextProviderProps {
  children: () => ReactNode
}

export const MercatusI18nextProvider: React.FC<MercatusI18nextProviderProps> = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const { data: user } = useUserInfo()
  const { data: preferenceInfo } = usePreferenceInfo()

  useEffect(() => {
    const doInit = async () => {
      await initI18next()
      setLoading(false)
    }
    void doInit()
  }, [setLoading])

  useEffect(() => {
    const newLocale = preferenceInfo?.locale ?? user?.impersonated?.locale ?? user?.real?.locale

    if (!loading && newLocale) {
      if (i18next.language !== newLocale) {
        i18next.changeLanguage(newLocale)
      }
    }
  }, [loading, user, preferenceInfo])

  if (loading) {
    return null
  }

  return <I18nextProvider i18n={i18next}>{children()}</I18nextProvider>
}
